/**
 * Payment-method display colours (Clinic Collection Details chart bars and
 * the Payment Method text in the report table).
 *
 * Keyed by the canonical `KnownPaymentMethod` type, so adding a method to
 * `PAYMENT_METHODS` without a colour is a type error. `text` is a darker
 * shade of `bar` so labels stay readable (≥ 4.5:1) on white surfaces. Red is
 * avoided — it is reserved for errors/danger. Unknown/legacy methods get no
 * colour and fall back to the default text / brand bar.
 */
import type { KnownPaymentMethod } from '@helios/domain';

export interface PaymentMethodColor {
  bar: string;
  text: string;
}

export const PAYMENT_METHOD_COLORS: Readonly<Record<KnownPaymentMethod, PaymentMethodColor>> = {
  cash: { bar: '#16a34a', text: '#15803d' }, // green
  card: { bar: '#7c3aed', text: '#6d28d9' }, // violet
  bank_transfer: { bar: '#d97706', text: '#b45309' }, // amber
  gcash: { bar: '#2563eb', text: '#1d4ed8' }, // blue
  other: { bar: '#64748b', text: '#475569' }, // slate
};

export function paymentMethodColor(
  value: string | null | undefined,
): PaymentMethodColor | undefined {
  if (!value) return undefined;
  return Object.prototype.hasOwnProperty.call(PAYMENT_METHOD_COLORS, value)
    ? PAYMENT_METHOD_COLORS[value as KnownPaymentMethod]
    : undefined;
}
